import { watch } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useDdQueueStore } from '@/stores/ddQueueStore'

/**
 * Derives D&D supervisor tier from products_design.supervisor.view (RBAC-SLICE-3).
 * Call once from the sidebar layout so nav filtering and queue supervisor UI stay in sync with RBAC.
 */
export function useDdPermitSync(): void {
  const authStore = useAuthStore()
  const ddQueueStore = useDdQueueStore()

  const sync = () => {
    if (!authStore.isAuthenticated) {
      ddQueueStore.syncPermitFromAuth(() => false)
      return
    }

    ddQueueStore.syncPermitFromAuth((permission) => authStore.hasPermission(permission))
  }

  watch(
    () => [authStore.isAuthenticated, authStore.user?.permissions, authStore.user?.roles] as const,
    sync,
    { immediate: true, deep: true },
  )
}
